import React, { useState, useEffect } from 'react';

const Section = () => {
  // State untuk countdown promo
  const [promoTimeLeft, setPromoTimeLeft] = useState({
    days: 7,
    hours: 12,
    minutes: 30,
    seconds: 45,
  });

  // Promo countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setPromoTimeLeft((prev) => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative overflow-hidden min-h-screen flex items-center">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source
            src="https://vcdn.makewebvideo.com/videos/technology_city_opening_logo_intro.mp4"
            type="video/mp4"
          />
        </video>
        {/* Video Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-blue-900/50 to-black/70"></div>
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center w-full">
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Paket Internet{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-400">
              Terbaik
            </span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-4xl mx-auto leading-relaxed">
            Pilih paket internet fiber yang sesuai dengan kebutuhan Anda. Dari rumah tangga
            hingga bisnis enterprise, kami punya solusinya dengan teknologi terdepan.
          </p>
        </div>

        {/* Promo Countdown */}
        <div className="glass-effect rounded-2xl p-6 mb-12 max-w-2xl mx-auto backdrop-blur-md">
          <div className="flex items-center justify-center mb-4">
            <h3 className="text-2xl font-bold">Promo Terbatas Berakhir Dalam:</h3>
          </div>
          <div className="flex justify-center gap-4">
            {Object.entries(promoTimeLeft).map(([unit, value]) => (
              <div
                key={unit}
                className="countdown-item rounded-xl p-4 text-center backdrop-blur-sm"
              >
                <div className="text-3xl font-bold text-white">
                  {value.toString().padStart(2, '0')}
                </div>
                <div className="text-sm text-gray-300 capitalize">{unit}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Buttons */}
        {/* <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <button
            onClick={() => document.getElementById('packages').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 pulse-animation shadow-2xl"
          >
            Lihat Semua Paket
          </button>
        </div> */}

        {/* Key Features Pills */}
        <div className="flex flex-wrap justify-center gap-4">
          {[
            { icon: '', text: 'Kecepatan hingga 1 Gbps' },
            { icon: '', text: 'Instalasi Gratis' },
            { icon: '', text: 'Support 24/7' },
            { icon: '', text: 'Unlimited Data' },
          ].map((feature, index) => (
            <div
              key={index}
              className="glass-effect px-4 py-2 rounded-full backdrop-blur-sm"
            >
              <span className="text-lg mr-2">{feature.icon}</span>
              <span className="text-sm font-semibold">{feature.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
      </div>
    </section>
  );
};

export default Section;